import { ArrowUpRightIcon } from "@heroicons/react/24/solid";

function MeshBG({ index }) {
  // We define DISTINCT color personalities for each card.
  // Format: [Color, PositionX%, PositionY%, Size%]
  const themes = [
    // 1. The "Sunset" (Pink, Yellow, Blue wash)
    [
      ["#FF0080", 10, 10, 70],    // Hot Pink Top Left
      ["#7928CA", 90, 90, 70],    // Purple Bottom Right
      ["#FF4D4D", 50, 50, 50],    // Red Center
    ],
    // 2. The "Ocean" (Deep Blue, Cyan, Lime)
    [
      ["#007CF0", 0, 100, 80],    // Azure Bottom Left
      ["#00DFD8", 100, 0, 70],    // Teal Top Right
      ["#7928CA", 50, 50, 40],    // Purple accent
    ],
    // 3. The "Candy" (Orange, Pink, Yellow)
    [
      ["#FF4D4D", 0, 0, 80],      // Red Top Left
      ["#F9CB28", 100, 100, 80],  // Yellow Bottom Right
      ["#FF0080", 100, 0, 50],    // Pink Top Right
    ],
    // 4. The "Northern Lights" (Green, Blue, Purple)
    [
      ["#7928CA", 0, 0, 70],      // Purple Top Left
      ["#FF0080", 100, 0, 50],    // Pink Top Right
      ["#00DFD8", 50, 100, 80],   // Cyan Bottom
    ],
    // 5. The "Heat" (Yellow, Orange, Red)
    [
      ["#F9CB28", 10, 50, 70],    // Yellow Left
      ["#FF4D4D", 90, 50, 70],    // Red Right
      ["#FB923C", 50, 0, 60],     // Orange Top
    ],
    // 6. The "Deep Space" (Indigo, Blue, Violet)
    [
      ["#4F46E5", 20, 20, 80],    // Indigo
      ["#C026D3", 80, 80, 80],    // Fuchsia
      ["#22D3EE", 50, 50, 50],    // Cyan Center
    ],
  ];

  // Select the theme based on index
  const activeTheme = themes[index % themes.length];

  // Create the gradient string
  const gradientString = activeTheme
    .map(
      ([color, x, y, size]) =>
        `radial-gradient(circle at ${x}% ${y}%, ${color} 0%, transparent ${size}%)`
    )
    .join(",");

  return (
    <div className="absolute inset-0 overflow-hidden bg-gray-50">
      <div
        className="absolute inset-0 w-full h-full opacity-90"
        style={{
          backgroundImage: gradientString,
          // Massive blur blends the distinct colors into a mesh
          filter: "blur(60px) saturate(1.4)", 
          // Scale up to hide blur edges
          transform: "scale(1.2)", 
        }}
      />
      {/* A subtle white noise or overlay can make it look more premium (optional) */}
      <div className="absolute inset-0 bg-white/20 mix-blend-overlay" />
    </div>
  );
}

export function EditorialCard({ title, index, onClick }) {
  return (
    <div
      onClick={onClick}
      className="group cursor-pointer bg-white rounded-2xl border border-gray-100
                 shadow-sm transition-all duration-300 
                 hover:shadow-xl hover:-translate-y-1 overflow-hidden"
    >
      {/* Top visual area */}
      <div className="relative h-48 sm:h-56 overflow-hidden flex items-center justify-center">
        <MeshBG index={index} />

        {/* The Icon Button */}
        <div className="relative z-10 w-12 h-12 rounded-full bg-white/90 backdrop-blur-sm 
                        flex items-center justify-center shadow-lg 
                        transition-transform duration-300 group-hover:scale-110">
          <ArrowUpRightIcon className="h-5 w-5 text-gray-900" />
        </div>
      </div>

      {/* Bottom text */}
      <div className="p-5">
        <h3 className="text-base font-bold text-gray-900 leading-tight">
          {title}
        </h3>
      </div>
    </div>
  );
}